module.exports = __webpack_public_path__ + "static/media/247_icon_dark.030bf46c.svg";